import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Header: FC = () => {
  const { t } = useTranslation();

  return (
    <Box style={{ padding: '20px' }}>
      <Typography variant="h4">{t('aiConfig:title')}</Typography>
    </Box>
  );
};
